import {
  GridCellParams,
  GridFilterItem,
  GridFilterModel,
  GridSortModel,
  GridSortItem,
  enUS,
  nlNL,
} from '@mui/x-data-grid-pro';

import {
  LocaleId,
  NextLink,
  OperatorTypes,
  Order,
} from '../../../constants/general';

export const getCellClassName = ({ field, value }: GridCellParams) => {
  const isStatusField = field === 'status';

  if (isStatusField) {
    return `request-status--${value}--cell`;
  }

  return '';
};

export const getFilterParams = (model?: GridFilterModel | null) => {
  const { items, linkOperator } = model || {};
  return {
    queryBlockSearches: items?.map((item: GridFilterItem, idx: number) => {
      const lastItem = items?.length - 1 === idx;
      return {
        fieldName: item.columnField,
        operatorTypes:
          OperatorTypes[item?.operatorValue as keyof typeof OperatorTypes],
        searchString: item.value as string,
        ...(!lastItem
          ? {
              nextLink: NextLink[linkOperator as keyof typeof NextLink],
            }
          : {}),
      };
    }),
  };
};

export const getSortParams = (items?: GridSortModel | null) => {
  return {
    orderByList: items?.map((item: GridSortItem) => ({
      orderBy: item.field,
      order: Order[item.sort as keyof typeof Order],
    })),
  };
};

export const getDataGridLocale = (loc?: string) => {
  const locales = {
    [LocaleId.EN]: enUS,
    [LocaleId.NL]: nlNL,
  };

  return locales[loc || LocaleId.EN]?.components.MuiDataGrid.defaultProps
    .localeText;
};
